import { Textfield } from '@workboard/wobo-ui';
import React, { FC, useCallback, useMemo, ComponentProps } from 'react';

interface IProps extends ComponentProps<typeof Textfield> {
  onChange?(e: React.ChangeEvent, val: string | undefined): void;
}

export const TimeField: FC<IProps> = ({ value, onChange, ...props }) => {
  const onChangeCallback = useCallback(
    (e) => {
      const val = e.target?.value;
      onChange(e, val);
    },
    [onChange]
  );
  const fieldValue = useMemo(
    () => (typeof value !== 'undefined' && value ? value : ''),
    [value]
  );
  return (
    <Textfield
      {...props}
      type="time"
      value={fieldValue}
      onChange={onChangeCallback}
    />
  );
};
